const Eye = () => (
    <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="7" r="4" fill="#979797" />
        <path d="M19 7C19 3.68629 14.9706 1 10 1C5.02944 1 1 3.68629 1 7" stroke="#979797" strokeLinecap="round" />
    </svg>
)

export default Eye
